import { render } from "./front-nav.vue?vue&type=template&id=3c8fd1ac&scoped=true"
import script from "./front-nav.vue?vue&type=script&lang=js"
export * from "./front-nav.vue?vue&type=script&lang=js"

import "./front-nav.vue?vue&type=style&index=0&id=3c8fd1ac&lang=scss&scoped=true"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3c8fd1ac"]])

export default __exports__